/**
 * Records how a deferred file upload should be committed after the user confirms
 * in the duplicate-file modal (replace vs rename) or when no conflict exists.
 */
export type FilestoreUploadCommitPlan =
    | { kind: "none" }
    | { kind: "unique" }
    | { kind: "replace"; deleteAttachmentName: string }
    | { kind: "rename" };

export const FILESTORE_UPLOAD_COMMIT_NONE: FilestoreUploadCommitPlan = { kind: "none" };
